import { Paths } from "@/core/constants/paths";
import { isAuthorizedForRule } from "@/modules/auth";
import type { RouteRule } from "@/routes/types";

export interface ControlPanelTab {
  label: string;
  path: string;
  testId: string;
  rule: RouteRule;
}

/** Ordem das abas: Usuários, Perfis e, na sequência, Permissões. */
export const CONTROL_PANEL_TABS: ControlPanelTab[] = [
  {
    label: "Usuários",
    path: Paths.CONTROL_PANEL_USERS,
    testId: "control-panel-tab-usuarios",
    rule: "admin",
  },
  {
    label: "Perfis",
    path: Paths.CONTROL_PANEL_ROLES,
    testId: "control-panel-tab-perfis",
    rule: "admin",
  },
  {
    label: "Permissões",
    path: Paths.CONTROL_PANEL_PERMISSIONS,
    testId: "control-panel-tab-permissoes",
    rule: "admin",
  },
  {
    label: "Auditoria",
    path: Paths.CONTROL_PANEL_AUDIT,
    testId: "control-panel-tab-auditoria",
    rule: "admin",
  },
];

export function useControlPanelTabs(): ControlPanelTab[] {
  return CONTROL_PANEL_TABS.filter((tab) => isAuthorizedForRule(tab.rule));
}
